
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ToStartIconComponent } from "./to-start-icon.svg";

export const ToStartIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ToStartIconComponent {...props} />;
};
